import React, { createContext, PropsWithChildren, useContext, useState } from 'react';

export type SettingsContent = {
    simulcast: boolean;
    setSimulcast(on: boolean): void;
    dynacast: boolean;
    setDynacast(on: boolean): void;
    adaptiveStream: boolean;
    setAdaptiveStream(on: boolean): void;
};

export const SettingsContext = createContext<SettingsContent>({} as SettingsContent);

// Отвечает за настройки комнаты
export const SettingsProvider = ({ children }: PropsWithChildren) => {
    const [simulcast, setSimulcast] = useState(true);
    const [dynacast, setDynacast] = useState(true);
    const [adaptiveStream, setAdaptiveStream] = useState(true);

    return (
        <SettingsContext.Provider
            value={{
                simulcast,
                setSimulcast,
                dynacast,
                setDynacast,
                adaptiveStream,
                setAdaptiveStream,
            }}
        >
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettingsContext = () => useContext(SettingsContext);
